import React from 'react';

const Footer = () => {
    return (
        <footer className="footer-area footer-eleven">
            <div className="footer-top">
                <div className="container">
                    <div className="inner-content">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="footer-widget f-about">
                                    <div className="logo">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </footer>
    );
};

export default Footer;